exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".gdprtext{margin-top:3rem;padding-bottom:2rem}#section-main-form form div[class*=col-].gdprtext-closed{padding-left:0;padding-right:0;margin-top:0;overflow-y:hidden;max-height:0;transition:max-height .4s ease-in-out}#section-main-form form div[class*=col-].gdprtext-forced{margin-top:0}#section-main-form form div[class*=col-].gdprtext-opened{max-height:2000px}.gdprtext-content-header{padding-top:4rem}.gdprtext-custom-content-header{padding-top:2rem}@media (max-width:768px){#section-main-form form div[class*=col-].gdprtext-opened{max-height:3000px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/gdprtext/gdprtext.styl
// module id = 149
// module chunks = 0 1